import { IsArray, IsDefined, IsInt } from 'class-validator';

export class GetStockSubstitutionsRecipesDto {
  @IsDefined()
  @IsArray()
  @IsInt({ each: true })
  recipeIds: number[];
}